import _ from 'lodash';

export const isNilOrEmpty = val => _.isNil(val) || _.isEmpty(_.trim(String(val)));
